export default "__VITE_ASSET__DsjOevEb__"